import React, { useState, useEffect, useRef } from 'react';
import { getCurrentCompany, createSubscription, cancelSubscription, getPayPalSubscription, getPlan, getClientId, createCheckout, updateSession, getSubscription } from '../../services/api';
import LabelledTextField from '../LabelledTextField';
import { dateOptions } from '../../utils/dates';
import globals from '../../utils/globals';
import useAuth from '../../services/authentication/useAuth';
import StripeSubscriptionSelection from './StripeSubscriptionSelection';
import CompanySubscriptionPlan from './CompanySubscriptionPlan';
import StripeSubscriptionDetials from './StripeSubscriptionDetails';

const CompanySubscription = () => {
  const [loading, setLoading] = useState(true);
  const [payPalClientId, setPayPalClientId] = useState(globals.payPalClientId);
  const [subscription, setSubscription] = useState(null);
  const [plan, setPlan] = useState(null);
  const [company, setCompany] = useState(null);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [startCancel, setStartCancel] = useState(false);
  const selectedPlanIdRef = useRef(selectedPlanId);
  const { refreshToken } = useAuth();
  const query = new URLSearchParams(window.location.search);
  const sessionId = query.get("session_id");

  useEffect(() => {
    setup();
  }, []);

  const setup = async () => {
    try {
      setLoading(true);
      const clientId = await getClientId();
      console.log(clientId);
      setPayPalClientId(clientId);

      if (sessionId) {
        await updateSession(sessionId);
        await refreshToken();
      }

      const companyResult = await getCurrentCompany();
      console.log(companyResult);
      setCompany(companyResult);
      console.log('Company', companyResult);
      if (companyResult.subscriptionId) {
        if (companyResult.subscriptionProvider === 'PayPal') {
          const payPalSubscriptionResult = await getPayPalSubscription(companyResult.subscriptionId);
          console.log(payPalSubscriptionResult);
          setSubscription(payPalSubscriptionResult);
          if (payPalSubscriptionResult?.planId) {
            const payPalPlanResult = await getPlan(payPalSubscriptionResult.planId);
            console.log(payPalPlanResult);
            setPlan(payPalPlanResult);
          }
        } else {
          const subscriptionResult = await getSubscription();
          setSubscription(subscriptionResult);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const setupPayPalClientId = async () => {
    const clientId = await getClientId();
    console.log(clientId);
    setPayPalClientId(clientId);
  };

  const setupCompany = async () => {
    const result = await getCurrentCompany();
    console.log(result);
    setCompany(result);
  };

  const setupSubscription = async (subscriptionId) => {
    try {
      if (subscriptionId !== null) {
        const result = await getPayPalSubscription(subscriptionId);
        console.log(result);
        setSubscription(result);
      }
    } catch (ex) {
      setLoading(false);
    }
  };

  const setupPlan = async (planId) => {
    try {
      console.log(planId);
      if (planId !== null) {
        const result = await getPlan(planId);
        console.log(result);
        setPlan(result);
      }
      setLoading(false);
    } catch (ex) {
      setLoading(false);
    }
  };

  const createPayPalSubscription = async (data, actions) => {
    console.log('Creating subscription...', data, actions);
    const subscriptionId = await createSubscription(selectedPlanIdRef.current);
    console.log(subscriptionId);
    return subscriptionId;
  };

  const onPayPalApprove = async (data, actions) => {
      console.log('Approving order...', data, actions);
      await setup();
      await refreshToken();
      // onApprove();
  };

  const onPayPalCancel = (data) => {
      console.log('cancel');
      console.log(data);
      console.log(JSON.stringify(data, null, 2));
      //alert(data);
  };

  const onPayPalError = (err) => {
      console.log('error');
      console.log(err)
      console.log(JSON.stringify(err, null, 2));
      //alert(err);
  };

  const onCancelSubscription = async (subscriptionId) => {
    try {
      await cancelSubscription(subscriptionId);
    } catch(ex) {
      console.log(ex);
    } finally {
      console.log(subscriptionId);
      setStartCancel(false);
    }
  };

  const onSelectionChange = id => {
    selectedPlanIdRef.current = id
    setSelectedPlanId(id);
  };

  const onCreateStripeSession = async () => {
    const result = await createCheckout();
    console.log(result);
    window.location.href = result.checkoutUrl;
  };

  const initialPayPalOptions = {
      "client-id": payPalClientId,
      components: "buttons",
      intent: "subscription",
      vault: true
  };

  const activeStripeStatuses = ["ACTIVE", "TRIALING", "PAST_DUE", "UNPAID", "PAUSED", "INCOMPLETE"];
  const activePayPalStatuses = ["ACTIVE"];

  let jsx = null;
  if (company?.subscriptionProvider === 'Stripe' && subscription && activeStripeStatuses.includes(subscription?.status.toUpperCase())) {
    jsx = <StripeSubscriptionDetials subscription={subscription} />
  } else if (company?.subscriptionProvider === 'PayPal' && subscription && activePayPalStatuses.includes(subscription?.status.toUpperCase())) {
    if (subscription?.status.toUpperCase() === "ACTIVE") {
      jsx = (
        <>
          <CompanySubscriptionPlan plan={plan} />
          <div className="card card-spaced">
            <LabelledTextField label="Subscription ID" text={subscription.id} />
            <LabelledTextField label="Status" text={subscription.status} />
            <LabelledTextField label="Last Payment" text={subscription?.latestPayment?.paymentDate ? new Date(subscription.latestPayment.paymentDate).toLocaleDateString('en-US', dateOptions) : ''} />
            <LabelledTextField label="Amount" text={subscription?.latestPayment?.amount ? '$' + subscription?.latestPayment?.amount.toFixed(2) : ''} />
            <LabelledTextField label="Next Due" text={subscription?.nextBillingDate ? new Date(subscription.nextBillingDate).toLocaleDateString('en-US', dateOptions) : ''} />
            {startCancel ? (
              <div className="form-actions">
                <span>Are you sure you want to cancel this subscription?</span>
                <button type="button" className="btn btn-danger" onClick={() => onCancelSubscription(subscription.id)}>Yes</button>
                <button type="button" className="btn btn-secondary" onClick={() => setStartCancel(false)}>No</button>
              </div>
            ) : (
              <div className="form-actions">
                <button type="button" className="btn btn-danger" onClick={() => setStartCancel(true)}>Cancel Subscription</button>
              </div>
            )}
          </div>
        </>
      );
    }
  } else {
    jsx = <StripeSubscriptionSelection />;
  }

  return loading ? <span className="spinner"></span> : jsx;
};

export default CompanySubscription;
